<template>
  <span>
    {{ field($i18n.locale) }}
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'field_name',
  props: {
    type: String,
    id: String,
    source_lang: String,
    target_lang: String,
  },
  data: function(){
    return {
      module_id: "62",
    };
  },
  computed: {
    ...mapGetters([
      'fields'
    ]),
    field: function(){
      return function(lang){
        if(!this.fields[this.type]){
          return this.id;
        }
        var lang = this.$i18n.locale;
        if(!this.fields[this.type][lang]){
          lang = "en";
        }
        var lang_pair = this.source_lang + "_" + this.target_lang;
        if(!this.fields[this.type][lang][lang_pair]){
          return this.id;
        }
        return this.fields[this.type][lang][lang_pair][this.id].name;
      }.bind(this);
    }
  }
}
</script>
